import { useState } from "react";
import { Collapse, IconButton, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import VisibilityIcon from "@mui/icons-material/Visibility";

export default function AnhangListe({ vst, onAction, t }) {
  const [open, setOpen] = useState(false);

  if (!vst?.anhang?.length) return null;

  if (vst.anhang.length === 1) {
    const datei = vst.anhang[0];

    return (
      <ListItem>
        <ListItemText
          primary={t("Anhang")}
          secondary={datei.name}
          primaryTypographyProps={{ fontWeight: "bold", color: "text.primary" }}
          secondaryTypographyProps={{ color: "text.primary", sx: { wordBreak: "break-word" } }}
        />
        <IconButton color="primary" aria-label={t("Anhang anzeigen")} onClick={() => onAction("einladung_download", { vstnr: vst.vstnr, docnr: datei.docnr, fileName: datei.name })}>
          <VisibilityIcon />
        </IconButton>
      </ListItem>
    );
  }

  return (
    <>
      <ListItemButton onClick={() => setOpen((prev) => !prev)}>
        <ListItemText
          primary={`${vst.anhang.length === 1 ? t("Anhang") : t("Anhänge")} (${vst.anhang.length})`}
          primaryTypographyProps={{ fontWeight: "bold" }}
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List disablePadding>
          {vst.anhang.map((datei) => (
            <ListItem key={`${datei.docnr}-${datei.key}`} sx={{ pl: 4 }}>
              <ListItemText primary={datei.name} primaryTypographyProps={{ sx: { wordBreak: "break-word" } }} />
              <IconButton color="primary" onClick={() => onAction("einladung_download", { vstnr: vst.vstnr, docnr: datei.docnr, fileName: datei.name })}>
                <VisibilityIcon />
              </IconButton>
            </ListItem>
          ))}
        </List>
      </Collapse>
    </>
  );
}
